import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { dv360ChannelsSelector, dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

import { targetingTypes } from '../../../LineItemDv360Create/fields'

export const useGetAttachedChannels = () => {
  const targeting = useSelector(dv360TargetingSelector)
  const dv360Channels = useSelector(dv360ChannelsSelector)

  const channelsTargetingOptions = useMemo(() => {
    return targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_CHANNEL)
  }, [targeting])

  const attachedChannels = useMemo(() => {
    return dv360Channels.filter(channel =>
      channelsTargetingOptions.some(option => option.channel_id === channel.id && !option.negative)
    )
  }, [dv360Channels, channelsTargetingOptions])

  const excludedAttachedChannels = useMemo(() => {
    return dv360Channels.filter(channel =>
      channelsTargetingOptions.some(option => option.channel_id === channel.id && option.negative)
    )
  }, [dv360Channels, channelsTargetingOptions])

  return useMemo(() => {
    return {
      attachedChannels,
      excludedAttachedChannels
    }
  }, [attachedChannels, excludedAttachedChannels])
}
